(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-information"]) return;
  try {
    
  class ConversionProductCountdown {
    constructor(element) {
      this.element = element;
      this.deadline = new Date(element.dataset.deadline).getTime();
      this.fields = {
        days: element.querySelector('[data-days]'),
        hours: element.querySelector('[data-hours]'),
        minutes: element.querySelector('[data-minutes]'),
        seconds: element.querySelector('[data-seconds]')
      };

      if (Number.isNaN(this.deadline)) return;

      this.update();
      if (!this.element.hidden) {
        this.interval = window.setInterval(() => this.update(), 1000);
      }
    }

    update() {
      const distance = this.deadline - Date.now();

      if (distance <= 0) {
        this.element.hidden = true;
        if (this.interval) window.clearInterval(this.interval);
        return;
      }

      this.element.hidden = false;
      const days = Math.floor(distance / 86400000);
      const hours = Math.floor((distance % 86400000) / 3600000);
      const minutes = Math.floor((distance % 3600000) / 60000);
      const seconds = Math.floor((distance % 60000) / 1000);

      this.fields.days.textContent = String(days).padStart(2, '0');
      this.fields.hours.textContent = String(hours).padStart(2, '0');
      this.fields.minutes.textContent = String(minutes).padStart(2, '0');
      this.fields.seconds.textContent = String(seconds).padStart(2, '0');
    }
  }

  const initializeConversionProducts = (root = document) => {
    const countdowns = root.matches?.('[data-countdown]')
      ? [root]
      : [...root.querySelectorAll('[data-countdown]')];

    countdowns.forEach((countdown) => {
      if (countdown.dataset.initialized === 'true') return;
      countdown.dataset.initialized = 'true';
      new ConversionProductCountdown(countdown);
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initializeConversionProducts());
  } else {
    initializeConversionProducts();
  }

  document.addEventListener('shopify:section:load', (event) => initializeConversionProducts(event.target));

  } catch(e) { console.error(e); }
})();
})();
